// --- Interfaces ---

interface Security {
    Id: number;
    Name: string;
}

interface Position {
    Security: Security;
    [key: string]: any;
}

interface AdaptAllocationsParams {
    data: {
        Positions?: Position[];
    };
    onAllocationChange: (value: { value: number; id: number }) => void;
    onCheckBoxChange: (value: { checked: boolean; id: number }) => void;
    t: (key: string) => string;
}

interface AllocationItem {
    id: number;
    name: {
        label: string;
        checked: boolean;
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    };
    allocation: {
        id: number;
        value: number;
        onChange: (value: { value: number; id: number }) => void;
        disabled: boolean;
    };
    factsheet: {
        securityId: number;
    };
}

interface AdaptAllocationsResult {
    body: AllocationItem[];
    footer: {
        name: string;
        allocation: number;
    };
}

// --- Implementation ---

export const adaptAllocations = ({
    data,
    onAllocationChange,
    onCheckBoxChange,
    t,
}: AdaptAllocationsParams): AdaptAllocationsResult => {
    const total = 0;
    const tableData: AdaptAllocationsResult = {
        body: [],
        footer: { name: '', allocation: 0 },
    };

    data?.Positions?.forEach((item) => {
        const securityId = item?.Security?.Id;
        const securityName = item?.Security?.Name;

        if (securityId) {
            tableData.body.push({
                id: securityId,
                name: {
                    label: securityName || '',
                    checked: false,
                    onChange: (e) => onCheckBoxChange({
                        checked: e.target.checked,
                        id: securityId,
                    }),
                },
                allocation: {
                    id: securityId,
                    value: 0,
                    onChange: onAllocationChange,
                    disabled: true,
                },
                factsheet: {
                    securityId,
                },
            });
        }
    });

    tableData.footer = {
        name: t('portfolio.createNewPortfolio.allocations.total'),
        allocation: total,
    };

    return tableData;
};
